import React, { useCallback, useEffect, useState } from "react";

import Skeleton from "@/components/dashboard/recommended/jobDescription/skeleton";

import { useSavedPageData } from "../";
import { useDashboardContext } from "../..";
import { DashboardContextProps, SavedPageContextProps } from "../types";
import { useJobDetails } from "./query";
import JobStatusCard from "./view";

const JobDescription = () => {
  const { isMobile }: DashboardContextProps = useDashboardContext();
  const { savedJobData, setSavedJobData }: SavedPageContextProps =
    useSavedPageData();

  const [selectedData, setSelectedData] = useState<any>({
    jobId: "",
    kiwiJobId: "",
    id: "",
  });

  const [loader, setLoader] = useState(true);
  const [enableAPI, setEnableAPI] = useState({
    enableJobStatusFetch:
      !savedJobData.newDataLoader && (selectedData?.jobId || selectedData?.id)
        ? true
        : false,
  });

  const { data: jobDetails } = useJobDetails(
    selectedData?.jobId || selectedData?.id,
    selectedData?.kiwiJobId,
    savedJobData?.profilePersonalDetails?.personalDetailSection?.personalDetails
      ?.uuid || "",
    savedJobData?.profilePersonalDetails?.isAutoRegistered || false,
    enableAPI.enableJobStatusFetch,
  );

  const mediaUrl = savedJobData.siteProps?.media_url || "media.foundit.in";

  const setLoaderOff = useCallback(() => {
    setTimeout(() => {
      setLoader(false);
      setTimeout(() => {
        document.body.style.overflow = "auto";
      }, 100);
    }, 200);
  }, [loader]);

  useEffect(() => {
    if (savedJobData.filterDisable) {
      setSavedJobData({
        ...savedJobData,
        jobDescIndex: { selectedIndex: isMobile ? undefined : 0 },
        filterDisable: false,
      });
    }
  }, [savedJobData.data]);

  useEffect(() => {
    if (!isMobile) {
      const savedDataNew =
        savedJobData.data?.[savedJobData.jobDescIndex?.selectedIndex || 0];
      setSelectedData(savedDataNew || {});
      setEnableAPI({
        enableJobStatusFetch:
          !savedJobData.newDataLoader &&
          (savedDataNew?.jobId || savedDataNew?.id)
            ? true
            : false,
      });
      if (selectedData?.id == savedDataNew?.jobDetails?.id) {
        setLoaderOff();
      }
    }
  }, [savedJobData.jobDescIndex]);

  useEffect(() => {
    if (savedJobData.isLoadingJobDesc) {
      setLoader(true);
      document.body.style.overflow = "hidden";
    }
  }, [savedJobData.isLoadingJobDesc]);

  useEffect(() => {
    if (jobDetails) {
      setLoaderOff();
    }
  }, [jobDetails]);

  const jobStatusCardComponent = (
    <div>
      {loader || savedJobData.isLoadingJobDesc ? (
        <Skeleton isMobile={isMobile} />
      ) : (
        <div>
          <JobStatusCard
            selectedData={selectedData}
            jobDescData={{
              jobDetails,
              filterStatusPresent: savedJobData.filterStatusPresent,
            }}
            siteProps={savedJobData?.siteProps || {}}
            sitePropsProperties={savedJobData?.sitePropsProperties || {}}
            loader={loader}
            mediaUrl={mediaUrl}
            leftSideRef={savedJobData.leftSideRef}
            savedJobs={savedJobData.savedJobs || []}
            saveUnsaveJobHandler={savedJobData.saveUnsaveJobHandler}
          />
        </div>
      )}
    </div>
  );

  return jobStatusCardComponent;
};

export default React.memo(JobDescription);
